// router/index.js

import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore} from '../store/AuthStore';

import InventoryView from '../views/Inventory/InventoryView.vue'
import ProductsView from '../views/Product/ProductsView.vue';
import ConditionsView from '../views/Conditions.vue';
import UserProfileView from '../views/Users/UserProfileView.vue';
import LoginBox from '../views/auth/LoginView.vue';
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path:"/",
    name:"home",
    component: HomeView,
    meta: { requiresAuth: false, hideMainMenu: true } 
  },
  {
    path: '/login',
    name: 'login',
    component: LoginBox,
    meta: { requiresAuth: false, hideMainMenu: true } 
  },
  {
    path: '/products',
    name: 'products',
    component: ProductsView,
    meta: { requiresAuth: true, roles:['Product creator'] } 
  },
  {
    path: '/inventory',
    name: 'inventory',
    component: InventoryView,
    meta: {requiresAuth: true, hideMainMenu: false, roles:['Basic user']}
  },
  {
    path: '/account',
    name: 'Account',
    component: UserProfileView,
    meta: { requiresAuth: true, roles:['Basic user'] }
  },
  {
    path:'/conditions',
    name: 'conditions',
    component: ConditionsView,
    meta:{requireAuth: false, hideMainMenu: true,}
  },
  // Route catch-all pour les pages inexistantes
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})


router.beforeEach(async (to, from, next) => {
  
  if (to.meta.requiresAuth) {
  const authStore = useAuthStore();
    if (!await authStore.checkAuth()) {
      next({ name: 'login' });
    } else {
      if (to.meta.roles && to.meta.roles.some(element => authStore.user.roles.includes(element))) {
        next(); // Autoriser l'accès
      } else {
        next({ path: from.fullPath }); 
      }
    }
  } else {
    next();
  }
});

export default router